import BaseChartCard from 'common/components/BaseChartCard'
import { useGetWaterBacteriaLineChart } from 'modules/water/api/queries'
import { VibrioChart } from 'modules/water/api/types'
import { Vibrios } from 'modules/water/constants'
import { getSeries } from 'modules/water/utils/chart'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { CategoryButtonGroup } from '../CategoryButtonGroup'
import LineChart from '../LineChart'

const BacteriaChart = () => {
  const { t } = useTranslation('water')
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  const [filter, setFilter] = useState<Vibrios>(Vibrios.Green)

  const { data, isFetching, refetch } = useGetWaterBacteriaLineChart()

  const series = getSeries<VibrioChart>(Vibrios, data)
  const chartData = [
    {
      id: Vibrios.Green,
      name: t('green.vibrio'),
      data: series[Vibrios.Green],
    },
    {
      id: Vibrios.Yellow,
      name: t('yellow.vibrio'),
      data: series[Vibrios.Yellow],
    },
  ]

  const filteredChartData = chartData.filter((item) => item.id === filter)

  const handleChange = (value: Vibrios) => {
    setFilter(value)
  }

  const getColor = (current: Vibrios) =>
    current === Vibrios.Green ? theme.palette.success.main : theme.palette.warning.main

  const options = chartData.map((item) => ({
    label: item.name,
    value: item.id,
  }))

  return (
    <BaseChartCard title={t('report.bacteria')} refresh={refetch}>
      <Stack direction="row" spacing={1} sx={{ overflowX: 'scroll', py: 2, pl: 2 }}>
        <CategoryButtonGroup<Vibrios>
          options={options}
          selected={filter}
          onChange={handleChange}
          size="small"
        />
      </Stack>
      <LineChart
        yData={filteredChartData}
        isLoading={isFetching}
        options={{ colors: [getColor(filter)] }}
        dataLength={data?.length || 0}
      />
    </BaseChartCard>
  )
}

export default BacteriaChart
